export const REGISTER_USER = "register_user";
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull";
export const REGISTER_USER_FAILED = "register_user_failed";
export const REGISTER_USER_DETAILS = "register_user_details";
export const SOCIAL_USER_SUCCESSFUL = "social_user_success";

export const API_ERROR = "register_error";
